module.exports = __webpack_public_path__ + "img/34.a191f9ca.jpg";